import { render } from "./NoticiaComponent.vue?vue&type=template&id=67563073&scoped=true"
import script from "./NoticiaComponent.vue?vue&type=script&lang=js"
export * from "./NoticiaComponent.vue?vue&type=script&lang=js"

import "./NoticiaComponent.vue?vue&type=style&index=0&id=67563073&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67563073"]])

export default __exports__